export default __webpack_public_path__ + "static/media/pic2.a1a52bc3.jpg";